import { AxiosResponse } from "axios";
import api from "../Interceptors/Interceptor";
import ApiResponse from "../Models/ApiResponse";
import { ResourceLocation } from "../Constants/resourceLocations";

export interface IReview {
    uuid: string;
    ratingScale: string;
    ratingValue: number;
    feedbackText?: string;
    createdAt?: string;
}

export interface IReviewSummary {
    count: number;
    ratingScale?: string;
    average?: number;
    /** The written feedback — only filled for whoever manages what is being reviewed. */
    feedback: string[];
    /** The current user's own rating and feedback; absent when they have not rated yet. */
    myRatingValue?: number | null;
    myFeedbackText?: string | null;
}

export class ReviewService {
    public async submitReview(
        location: ResourceLocation,
        locationIdentifier: string,
        ratingScale: string,
        ratingValue: number,
        feedbackText?: string
    ): Promise<AxiosResponse<ApiResponse<IReview>>> {
        return api.post("v1/review", { location, locationIdentifier, ratingScale, ratingValue, feedbackText });
    }

    /** Takes the current user's own rating (and feedback) back; it no longer counts in the summary. */
    public async withdrawReview(
        location: ResourceLocation,
        locationIdentifier: string
    ): Promise<AxiosResponse<ApiResponse<void>>> {
        return api.delete("v1/review", { params: { location, locationIdentifier } });
    }

    public async fetchSummary(
        location: ResourceLocation,
        locationIdentifier: string
    ): Promise<AxiosResponse<ApiResponse<IReviewSummary>>> {
        return api.get("v1/review/summary", { params: { location, locationIdentifier } });
    }
}
